import React from "react";
import "./Videos.css";
import { Link } from "react-router-dom";
import { VideoItems } from "./videoData";
import { Seo } from "../seo/Seo";

export interface IVideosProps {
  youtubeId: string;
}

export interface IVideosState { }

export class Videos extends React.Component<IVideosProps, IVideosState> {
  constructor(props: IVideosProps) {
    super(props);
    this.state = {};
  }

  public render() {
    return (
      <div>
        <Seo
          title="Videos — Valere Kissi | Cinematographer in Sioux Falls, SD"
          description="Music videos, fashion films, wedding and travel films shot and graded by Valere Kissi, cinematographer and colorist in Sioux Falls, South Dakota."
          path="/videos"
        />
        <div className="videos-container">
          {VideoItems.map((video) => (
            <Link
              className="videos-item"
              to={`player?videoId=${video.youtubeId}`}
              key={video.youtubeId}
            >
              <img
                alt={video.title}
                src={video.thumbnail}
                width={video.width}
                height={video.height}
                loading="lazy"
              />
            </Link>
          ))}
        </div>
      </div>
    );
  }
}
